import React from 'react';

import { Footer, Header } from '$partials/global';
import { SimpleImage } from '$partials/media';
import { ModuleDispatcher } from '$partials/modules';
import { OfficeProvider } from '$contexts/office';
import { CtaBannerBlock } from '$partials/modules/blocks';
import OfficeSchema from '$partials/offices/office-schema.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 *
 * @type {import('$types/components/pages').OfficeDetailPage}
 */
const OfficeDetailPage = (props) => {
    const page = props.data.page;

    return (
        <>
            <OfficeSchema
                page={page}
                socialLinks={props.data.footer?.socialLinks}
                url={props?.location} />

            <Header
                {...props.data.header}
                defaultOffice={{
                    id: page.id,
                    title: page.title,
                }} />

            <main id='main-content'>
                <header className='theme-light-alt bg-main-background'>
                    <div className='layout-container layout-site-outer-padding md:pt-160 md:pb-48'>
                        <h1 className='text-main-text-primary type-style-1'>
                            {page?.title}
                        </h1>
                    </div>
                    {page?.coverImage && (
                        <SimpleImage
                            className='w-full h-[245px] sm:h-[540px] md:h-[810px] object-cover'
                            {...page.coverImage}/>
                    )}
                </header>

                {page?.modules?.length > 0 && (
                    <OfficeProvider
                        contact={{
                            id: page.id,
                            title: page.title,
                            address: page.address,
                            coordinates: page.coordinates,
                            officeEmail: page.officeEmail,
                            primaryPhoneNumber: page.primaryPhoneNumber,
                            secondaryPhoneNumber: page.secondaryPhoneNumber,
                            disclaimerText: props.data.enquiryForm?.disclaimerText
                        }}
                        externalId={page.externalId}
                        rentalProperties={page.rentalProperties}
                        saleProperties={page.saleProperties}>
                        <section className='theme-light-alt'>
                            {page.modules.map((module, i) => (
                                <ModuleDispatcher
                                    {...module}
                                    key={i + module?.id}/>
                            ))}
                        </section>
                    </OfficeProvider>
                )}
            </main>
            <CtaBannerBlock
                body={props.data.footer?.getInTouchBodyText}
                defaultOffice={{
                    id: page?.id,
                    title: page?.title
                }}
                heading={props.data.footer?.getInTouchHeadingText}
                opensDialog={true}/>
            <Footer {...props.data.footer} />
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default OfficeDetailPage;
